import axios from '@/api';

export default {
  async createApplication({ rootGetters }, { application }) {
    return axios.post('interiorDesign', application, {
      headers: { recaptcha: rootGetters['getGoogleVerifyKey'] },
    });
  },
};
